import { ConstrainedItem, ConstrainedObject, ConstraintScope } from '@Models';

export const findConstrainedTopParent = (
  elements: ConstrainedObject[],
  item: ConstrainedObject,
): ConstrainedItem => {
  const element = elements.find(
    (i) => i.type === item.parent.type && i.id === item.parent.id,
  );
  if (!element) {
    return item.parent;
  }

  return findConstrainedTopParent(elements, element);
};

export const findConstrainedParentByScope = (
  elements: ConstrainedObject[],
  item: ConstrainedObject,
  scope: ConstraintScope,
): ConstrainedItem => {
  if (scope === ConstraintScope.Parent) {
    return item.parent;
  }

  return findConstrainedTopParent(elements, item);
};
